<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  durations: object;
  checkAvailableDate: boolean;
}
const props = defineProps<Props>();

const durationString = computed(() => {
  const values = props.durations ? Object.values(props.durations) : [];
  return values.join(', ');
});
</script>
<template>
  <div class="seasonal-duration flex" v-if="durationString && checkAvailableDate">
    <span class="labels max-w-18rem white-space-normal"
      >{{ $t('common.labels.durations') + ': ' }} <span class="durations_txt">{{ durationString }}</span></span
    >
  </div>
</template>
<style lang="scss" scoped>
.p-inputtext.p-component {
  height: 30px;
}
</style>
